import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { v4 as uuidv4 } from 'uuid';
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from 'reactstrap';
import $ from 'jquery';
import { injectIntl } from 'react-intl';

import { showModal } from '../actions';
import { showConfirmationModal } from '../actions/App';
import {
  showCollectionAddModal,
  removeFilesFromCollection,
  setSidebarCollection,
  addFilesToSidebarCollectionFilesList,
  setSelectedCollections,
  deleteCollections,
  showCollectionMoveModal,
  setSelectedAllCollections,
  deleteCollectionsPermanent,
} from '../actions/Collections';
import {
  setSelectedFiles,
  setSelectedAllFiles,
  showUploadModal,
  setUploadModalMode,
  deleteFiles,
  removeFilesFromFilesList,
  deleteFilesPermanent,
  restoreDeletedFiles,
} from '../actions/Files';

import { APIaddFilesToCollection } from '../api/Collections';
import { APIcreateFilesGroup } from '../api/Files';

import FileActionsIntegrations from './File/ActionsIntegrations';
import FileDesignPickleIntegrationButton from './File/DesignPickleIntegrationButton';
import UpgradePlanButton from './UpgradePlanButton';

import {
  hideIntercomWidget,
  showIntercomWidget,
} from '../helpers';
import {
  getState,
  isArchive,
  isTrash,
} from '../helpers/App';
import {
  userCan,
  userHasCap,
  userIsAdmin,
  userIsManager,
} from '../helpers/Auth';
import { userHasFeature } from '../helpers/Features';
import { getCurrentFileFilters } from '../helpers/Files';
import { addFlashMessage } from '../helpers/FlashMessages';
import { getSetting } from '../helpers/Settings';
import { upgradeModalIfNeeded } from '../helpers/UpgradePlan';

class ActionbarWorkspaceActions extends PureComponent {
  constructor(props) {
    super(props);

    this.handleRemoveFromCollection = this.handleRemoveFromCollection.bind(this);
    this.selectAllFiles = this.selectAllFiles.bind(this);
  }

  componentDidUpdate() {
    const {
      share,
      selectedCollections,
      selectedFiles,
    } = this.props;

    const moreElements = $('.actionbar .action-more .dropdown-menu button').length;
    if (moreElements > 0) {
      $('.actionbar .action-more').removeClass('hidden');
    } else {
      $('.actionbar .action-more').addClass('hidden');
    }

    if (!share) {
      return;
    }

    if (selectedCollections.length === 0 && selectedFiles.length === 0) {
      showIntercomWidget();
    } else {
      hideIntercomWidget();
    }
  }

  getSelectedFilesWithCap(cap) {
    const { selectedFiles } = this.props;

    return selectedFiles.filter(sf => (userCan(cap, sf)));
  }

  isSelectedAllFilesActionLocked() {
    const {
      selectedAllFiles,
      selectedAllCollections,
      selectedFiles, filesTotal,
    } = this.props;

    return (selectedAllFiles && selectedFiles.length !== filesTotal) ||
      selectedAllCollections;
  }

  getShareLabel() {
    const { intl } = this.props;

    if (this.isSelectedAllFilesActionLocked()) {
      return intl.formatMessage({
        defaultMessage: 'Load all files to share',
      });
    }

    if (this.showFilesAccessButton() || this.showCollectionsAccessButton()) {
      return intl.formatMessage({
        defaultMessage: 'Access & Share',
      });
    }
    return intl.formatMessage({
      defaultMessage: 'Share a link',
    });
  }

  getEditLabel() {
    const { intl } = this.props;

    if (this.isSelectedAllFilesActionLocked()) {
      return intl.formatMessage({
        defaultMessage: 'Load all files to edit',
      });
    }

    if (this.showEditButton()) {
      return intl.formatMessage({
        defaultMessage: 'Edit',
      });
    }

    if (!this.isSelectedFileWithCap('file.edit')) {
      return intl.formatMessage({
        defaultMessage: 'You don\'t have permission to edit the selected file(s)',
      });
    }

    return intl.formatMessage({
      defaultMessage: 'Unselect link card(s) to edit',
    });
  }

  selectAllFiles() {
    const {
      files,
      selectFiles,
    } = this.props;

    selectFiles(files);
  }

  isSelectedFileWithCap(cap) {
    const { selectedFiles } = this.props;

    let show = false;
    for (let i = 0; i < selectedFiles.length; i += 1) {
      if (userCan(cap, selectedFiles[i])) {
        show = true;
        break;
      }
    }

    return show;
  }

  isSelectedCollectionWithCap(cap) {
    const { selectedCollections } = this.props;

    let show = false;
    for (let i = 0; i < selectedCollections.length; i += 1) {
      if (userCan(cap, selectedCollections[i])) {
        show = true;
        break;
      }
    }

    return show;
  }

  showRequestDownloadButton() {
    const { selectedFiles } = this.props;

    return (this.isSelectedFileWithCap('file.request_download') && selectedFiles.length > this.getSelectedFilesWithCap('file.download').length) ||
      this.isSelectedCollectionWithCap('collection.request_download');
  }

  showDownloadButton() {
    return this.isSelectedFileWithCap('file.download') || this.isSelectedCollectionWithCap('collection.download');
  }

  showDownloadRequestButton() {
    const {
      selectedFiles,
      collection,
    } = this.props;
    return collection && collection.request && selectedFiles.filter(f => (f.request)).length > 0;
  }

  showArchiveButton() {
    return this.isSelectedFileWithCap('file.archive') || this.isSelectedCollectionWithCap('collection.archive');
  }

  showShareButton() {
    return (this.isSelectedFileWithCap('file.share') || this.isSelectedCollectionWithCap('collection.share')) && userHasCap('share');
  }

  showDeleteFilesButton() {
    return this.isSelectedFileWithCap('file.delete') && !this.isSelectedCollectionWithCap('collections.delete');
  }

  showDeleteCollectionsButton() {
    return this.isSelectedCollectionWithCap('collection.delete') && !this.isSelectedFileWithCap('file.delete');
  }

  showEditButton() {
    const { selectedFiles } = this.props;
    const links = selectedFiles.filter(sf => (sf.type === 'link')).length;
    const nonLinks = selectedFiles.filter(sf => (sf.type !== 'link')).length;

    return this.isSelectedFileWithCap('file.edit') && (links === 0 || nonLinks === 0);
  }

  showWatermarkButton() {
    const { selectedFiles } = this.props;

    if (!this.showEditButton()) {
      return false;
    }

    const canBeWatermarked = !!(selectedFiles.find(sf => (sf.can_be_watermarked)));

    return canBeWatermarked;
  }

  showChangeStatusButton() {
    const { share } = this.props;

    return this.showEditButton() || share?.status_change;
  }

  showFilesAccessButton() {
    return this.isSelectedFileWithCap('file.change_access') && !this.isSelectedCollectionWithCap('collection.change_access');
  }

  showCollectionsAccessButton() {
    return this.isSelectedCollectionWithCap('collection.change_access') && !this.isSelectedFileWithCap('file.change_access');
  }

  showChangeFilesOwnerButton() {
    const { selectedCollections } = this.props;

    return userCan('file.change_owner') && selectedCollections.length === 0;
  }

  showChangeCollectionsOwnerButton() {
    const { selectedFiles } = this.props;

    return userCan('collection.change_owner') && selectedFiles.length === 0;
  }

  handleRemoveFromCollection() {
    const {
      intl,
      openConfirmationModal,
      collection,
      deleteFilesFromCollection,
      unselectAllFiles,
      selectedFiles,
      selectedAllFiles,
      filesTotal,
    } = this.props;

    const filesCount = selectedAllFiles ? filesTotal : selectedFiles.length;
    const progressGroupUuid = uuidv4();

    const modalParams = {
      title: intl.formatMessage({
        defaultMessage: 'Are you sure?',
      }),
      text: intl.formatMessage({
        defaultMessage: 'Do you want to remove {filesCount} {filesCount, plural, one {file} other {files}} from {collectionName} Collection?',
      }, {
        filesCount,
        collectionName: collection.name,
      }),
      processingText: intl.formatMessage({
        defaultMessage: 'Removing',
      }),
      onConfirm: () => (
        deleteFilesFromCollection(collection.uuid, {
          files: selectedFiles.map(sf => (sf.uuid)),
          selectedAllFiles,
          filters: selectedAllFiles ? getCurrentFileFilters() : undefined,
          progressGroupUuid,
        }).then(() => {
          unselectAllFiles();
        })
      ),
      progressGroupUuid,
    };
    openConfirmationModal(modalParams);
  }

  handleDeleteFiles() {
    const {
      intl,
      openConfirmationModal,
      deleteFilesAction,
      unselectAllFiles,
      selectedFiles,
      selectedAllFiles,
      filesTotal,
    } = this.props;

    const availableFiles = selectedFiles.filter(f => (userCan('file.delete', f)));
    const filesCount = selectedAllFiles ? filesTotal : availableFiles.length;
    const progressGroupUuid = uuidv4();

    const modalParams = {
      title: intl.formatMessage({
        defaultMessage: 'Are you sure?',
      }),
      text: intl.formatMessage({
        defaultMessage: 'Do you want to delete {filesCount} {filesCount, plural, one {file} other {files}}? Files can be restored from trash.',
      }, {
        filesCount,
      }),
      confirmText: intl.formatMessage({
        defaultMessage: 'Delete',
      }),
      processingText: intl.formatMessage({
        defaultMessage: 'Deleting',
      }),
      onConfirm: () => (
        deleteFilesAction({
          files: availableFiles.map(sf => (sf.uuid)),
          selectedAllFiles,
          filters: selectedAllFiles ? getCurrentFileFilters() : undefined,
          progressGroupUuid,
        }).then(() => {
          unselectAllFiles();
        })
      ),
      progressGroupUuid,
    };
    openConfirmationModal(modalParams);
  }

  handleDeleteFilesPermanent(files) {
    const {
      intl,
      openConfirmationModal,
      deleteFilesPermanentAction,
      unselectAllFiles,
      selectedAllFiles,
      filesTotal,
    } = this.props;

    const availableFiles = files.filter(f => (userCan('file.delete', f)));
    const filesCount = selectedAllFiles ? filesTotal : availableFiles.length;
    const progressGroupUuid = uuidv4();

    const modalParams = {
      title: intl.formatMessage({
        defaultMessage: 'Are you sure?',
      }),
      warning: intl.formatMessage({
        defaultMessage: 'You are permanently deleting {filesCount} {filesCount, plural, one {file} other {files}}.',
      }, {
        filesCount,
      }),
      text: intl.formatMessage({
        defaultMessage: 'If you delete {filesCount, plural, one {this file it} other {these files they}} will be deleted permanently from your workspace and all collections it may be a part of - this can not be undone!',
      }, {
        filesCount,
      }),
      confirmText: intl.formatMessage({
        defaultMessage: 'Permanently delete',
      }),
      processingText: intl.formatMessage({
        defaultMessage: 'Deleting',
      }),
      onConfirm: () => (
        deleteFilesPermanentAction({
          files: availableFiles.map(sf => (sf.uuid)),
          selectedAllFiles,
          filters: selectedAllFiles ? getCurrentFileFilters() : undefined,
          progressGroupUuid,
        }).then(() => {
          unselectAllFiles();
        })
      ),
      progressGroupUuid,
    };
    openConfirmationModal(modalParams);
  }

  handleRestoreFiles(files) {
    const {
      intl,
      openConfirmationModal,
      restoreFilesAction,
      unselectAllFiles,
      selectedAllFiles,
      filesTotal,
    } = this.props;

    const availableFiles = files.filter(f => (userCan('file.delete', f)));
    const filesCount = selectedAllFiles ? filesTotal : availableFiles.length;
    const progressGroupUuid = uuidv4();

    const modalParams = {
      title: intl.formatMessage({
        defaultMessage: 'Are you sure?',
      }),
      text: intl.formatMessage({
        defaultMessage: 'Do you want to restore {filesCount} {filesCount, plural, one {file} other {files}}?',
      }, {
        filesCount,
      }),
      confirmText: intl.formatMessage({
        defaultMessage: 'Restore',
      }),
      processingText: intl.formatMessage({
        defaultMessage: 'Restoring',
      }),
      onConfirm: () => (
        restoreFilesAction({
          files: availableFiles.map(sf => (sf.uuid)),
          selectedAllFiles,
          filters: selectedAllFiles ? getCurrentFileFilters() : undefined,
          progressGroupUuid,
        }).then(() => {
          unselectAllFiles();
        })
      ),
      progressGroupUuid,
    };
    openConfirmationModal(modalParams);
  }

  handleDeleteCollections() {
    const {
      openRemoveCollectionModal,
      removeCollections,
      unselectAllCollections,
      selectedCollections,
    } = this.props;

    const availableCollections = selectedCollections.filter(c => (userCan('collection.delete', c)));

    const progressFilesUuid = uuidv4();
    const progressCollectionsUuid = uuidv4();
    const modalParams = {
      collections: availableCollections,
      progressFilesUuid,
      progressCollectionsUuid,
      onConfirm: (withFiles = false) => (
        removeCollections({
          collectionUuidList: availableCollections.map(sf => (sf.uuid)),
          progressCollectionsUuid,
          progressFilesUuid,
          withFiles,
        }).then(() => {
          unselectAllCollections();
        })
      ),
    };
    openRemoveCollectionModal(modalParams);
  }

  handleDeleteCollectionsPermanent() {
    const {
      intl,
      removeCollectionsPermanent,
      selectedCollections,
      openRemoveCollectionModal,
    } = this.props;
    const progressFilesUuid = uuidv4();
    const modalParams = {
      collections: selectedCollections,
      progressFilesUuid,
      mode: 'permanent',
      onConfirm: (withFiles = false) => (
        removeCollectionsPermanent({
          collectionUuidList: selectedCollections.map(c => c.uuid),
          progressFilesUuid,
          withFiles,
        }).then((response) => {
          const { data } = response;
          if (data && data.errors) {
            addFlashMessage({
              type: 'error',
              text: intl.formatMessage({ defaultMessage: 'An error occurred while permanently deleting collections' }),
            });
          } else {
            addFlashMessage({
              type: 'success',
              text: intl.formatMessage({ defaultMessage: 'Collections have been deleted permanently' }),
            });
          }
        }).catch(() => {
          addFlashMessage({
            type: 'error',
            message: intl.formatMessage({ defaultMessage: 'An error occurred while permanently deleting collections' }),
          });
        })
      ),
    };
    openRemoveCollectionModal(modalParams);
  }

  handleRestoreDeletedCollections() {
    const {
      selectedCollections,
      openCollectionRestoreModal,
    } = this.props;

    openCollectionRestoreModal({
      restoringCollections: selectedCollections.map(c => c.uuid),
      initialParentUuid: selectedCollections.find(c => c.attributes?.parent_before_delete),
    });
  }

  canUserMoveCollection() {
    const { selectedCollections } = this.props;
    return selectedCollections.filter(sc => (userCan('collection.edit', sc))).length > 0;
  }

  render() {
    const {
      intl,
      profile,
      share,
      selectedFiles,
      selectedCollections,
      collection,
      sidebarCollection,
      handleAddToCollection,
      handleAddToSidebarCollection,
      handleMoveToCollection,
      handleMoveCollectionToCollection,
      handleEditFiles,
      handleDownload,
      handleRequestDownload,
      handleDownloadRequest,
      handleShare,
      handleChangeStatus,
      handleChangeWatermarked,
      handleChangeFilesOwner,
      handleChangeCollectionsOwner,
      handleChangeFilesAccess,
      handleChangeCollectionsAccess,
      handleArchive,
      reorderingMode,
    } = this.props;
    const totalSelectedFiles = selectedFiles.length;
    const totalSelectedCollections = selectedCollections.length;
    const lockSelectedAllFilesAction = this.isSelectedAllFilesActionLocked();

    const watermarkEnabled = !!profile?.client?.watermark_url;

    if (reorderingMode) {
      return null;
    }

    return (
      <>
        {isTrash() ? (
          <Nav className="ml-auto" navbar>
            {(totalSelectedFiles > 0 && totalSelectedCollections === 0) && (
              <>
                <NavItem>
                  <NavLink
                    id="ABRestoreFromTrash"
                    href="#restore-from-trash"
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleRestoreFiles(selectedFiles);
                    }}
                    disabled={lockSelectedAllFilesAction}
                  >
                    <i className="far fa-fw fa-trash-undo" />
                  </NavLink>
                  <UncontrolledTooltip fade={false} placement="top" target="ABRestoreFromTrash">
                    {intl.formatMessage({
                      defaultMessage: 'Restore',
                    })}
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink
                    id="ABDeletePermanent"
                    href="#add-to-sidebar-collection"
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleDeleteFilesPermanent(selectedFiles);
                    }}
                    disabled={lockSelectedAllFilesAction}
                  >
                    <i className="fas fa-fw fa-trash" />
                  </NavLink>
                  <UncontrolledTooltip fade={false} placement="top" target="ABDeletePermanent">
                    {intl.formatMessage({
                      defaultMessage: 'Delete permanently',
                    })}
                  </UncontrolledTooltip>
                </NavItem>
              </>
            )}
            {(totalSelectedCollections > 0 && totalSelectedFiles === 0) && (
              this.showDeleteCollectionsButton() && (
                <>
                  <NavItem>
                    <NavLink
                      id="ABRestoreCollections"
                      href="#restore-collections"
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleRestoreDeletedCollections();
                      }}
                    >
                      <i className="far fa-fw fa-trash-undo" />
                    </NavLink>
                    <UncontrolledTooltip fade={false} placement="top" target="ABRestoreCollections">
                      {intl.formatMessage({
                        defaultMessage: 'Restore',
                      })}
                    </UncontrolledTooltip>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      id="ABDeleteCollectionsPermanent"
                      href="#delete-collection-permanent"
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleDeleteCollectionsPermanent(selectedCollections);
                      }}
                    >
                      <i className="fas fa-fw fa-trash" />
                    </NavLink>
                    <UncontrolledTooltip fade={false} placement="top" target="ABDeleteCollectionsPermanent">
                      {intl.formatMessage({
                        defaultMessage: 'Delete permanently',
                      })}
                    </UncontrolledTooltip>
                  </NavItem>
                </>
              )
            )}
          </Nav>
        ) : (
          <Nav className="ml-auto" navbar>
            {!share && (
              <FileDesignPickleIntegrationButton files={selectedFiles} />
            )}
            {(!share && ((!isArchive() || getSetting('cs1')) && totalSelectedFiles > 0 && totalSelectedCollections === 0)) && (
              <>
                {(sidebarCollection &&
                  !isArchive() &&
                  sidebarCollection.open
                ) && (
                <NavItem>
                  <NavLink
                    id="ABAddToSidebarCollection"
                    href="#add-to-sidebar-collection"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddToSidebarCollection(sidebarCollection.uuid, selectedFiles);
                    }}
                    disabled={lockSelectedAllFilesAction}
                  >
                    <i className="far fa-folder-plus" />
                  </NavLink>
                  <UncontrolledTooltip fade={false} placement="top" target="ABAddToSidebarCollection">
                    {lockSelectedAllFilesAction ?
                      intl.formatMessage({
                        defaultMessage: 'Load all files to add to {sidebarCollectionName}',
                      }, {
                        sidebarCollectionName: sidebarCollection.name,
                      }) :
                      intl.formatMessage({
                        defaultMessage: 'Add to {sidebarCollectionName}',
                      }, {
                        sidebarCollectionName: sidebarCollection.name,
                      })}
                  </UncontrolledTooltip>
                </NavItem>
                )}
                {userCan('add_files_to_collections') && (
                  <NavItem>
                    <NavLink
                      id="ABAddToCollection"
                      href="#add-to-collection"
                      onClick={handleAddToCollection}
                    >
                      <i className="far fa-layer-plus" />
                    </NavLink>
                    <UncontrolledTooltip fade={false} placement="top" target="ABAddToCollection">
                      {intl.formatMessage({ defaultMessage: 'Add to Collection' })}
                    </UncontrolledTooltip>
                  </NavItem>
                )}
              </>
            )}
            {(!share && (
              collection && collection.open && !collection.smart && userCan('collection.remove', collection) &&
              totalSelectedFiles > 0 && totalSelectedCollections === 0
            )) && (
            <NavItem>
              <NavLink
                id="ABRemoveFromCollection"
                href="#remove-from-collection"
                onClick={(e) => {
                  e.preventDefault();
                  this.handleRemoveFromCollection();
                }}
              >
                <i className="far fa-layer-minus" />
              </NavLink>
              <UncontrolledTooltip fade={false} placement="top" target="ABRemoveFromCollection">
                {intl.formatMessage({ defaultMessage: 'Remove from Collection' })}
              </UncontrolledTooltip>
            </NavItem>
            )}
            {(!share && (
              collection && collection.open && userCan('add_files_to_collections') && userCan('collection.remove', collection) &&
              totalSelectedFiles > 0 && totalSelectedCollections === 0
            )) && (
            <NavItem>
              <NavLink
                id="ABMoveToCollection"
                href="#move-to-collection"
                onClick={handleMoveToCollection}
              >
                <i className="far fa-arrow-alt-right" />
              </NavLink>
              <UncontrolledTooltip fade={false} placement="top" target="ABMoveToCollection">
                {intl.formatMessage({ defaultMessage: 'Move to Collection' })}
              </UncontrolledTooltip>
            </NavItem>
            )}
            {(!share && (totalSelectedFiles === 0 && totalSelectedCollections > 0 && !(getSetting('cs1') && !userIsAdmin())) && this.canUserMoveCollection()) && (
              <NavItem>
                <NavLink
                  id="ABMoveCollectionToCollection"
                  href="#move-to-collection"
                  onClick={(e) => {
                    e.preventDefault();
                    handleMoveCollectionToCollection();
                  }}
                >
                  <i className="far fa-arrow-alt-right" />
                </NavLink>
                <UncontrolledTooltip fade={false} placement="top" target="ABMoveCollectionToCollection">
                  {intl.formatMessage({ defaultMessage: 'Move to Collection' })}
                </UncontrolledTooltip>
              </NavItem>
            )}
            {(!share && this.showDownloadRequestButton()) && (
              <NavItem>
                <NavLink
                  id="ABDownloadRequest"
                  href="#download-request"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDownloadRequest(
                      selectedCollections,
                      selectedFiles,
                      collection.request,
                    );
                  }}
                  disabled={lockSelectedAllFilesAction}
                >
                  <i className="far fa-download" />
                </NavLink>
                <UncontrolledTooltip fade={false} placement="top" target="ABDownloadRequest">
                  {lockSelectedAllFilesAction ?
                    intl.formatMessage({
                      defaultMessage: 'Load all files to download',
                    }) :
                    intl.formatMessage({
                      defaultMessage: 'Download',
                    })}
                </UncontrolledTooltip>
              </NavItem>
            )}
            {!share && this.showRequestDownloadButton() && (
              <NavItem>
                <NavLink
                  id="ABRequestDownload"
                  href="#request-download"
                  onClick={(e) => {
                    e.preventDefault();
                    handleRequestDownload(selectedCollections, selectedFiles);
                  }}
                  disabled={lockSelectedAllFilesAction}
                >
                  <i className="far fa-cart-arrow-down" />
                </NavLink>
                <UncontrolledTooltip fade={false} placement="top" target="ABRequestDownload">
                  {lockSelectedAllFilesAction ?
                    intl.formatMessage({ defaultMessage: 'Load all files to request download' }) :
                    intl.formatMessage({ defaultMessage: 'Request Download' })}
                </UncontrolledTooltip>
              </NavItem>
            )}
            {(this.showDownloadButton()) && (
              <NavItem>
                <NavLink
                  id="ABDownload"
                  href="#download"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDownload(selectedCollections, selectedFiles, share);
                  }}
                  disabled={lockSelectedAllFilesAction}
                >
                  <i className="far fa-download" />
                </NavLink>
                <UncontrolledTooltip fade={false} placement="top" target="ABDownload">
                  {lockSelectedAllFilesAction ?
                    intl.formatMessage({ defaultMessage: 'Load all files to download' }) :
                    intl.formatMessage({ defaultMessage: 'Download' })}
                </UncontrolledTooltip>
              </NavItem>
            )}
            {(
              !share && (!isArchive() || getSetting('cs1')) &&
              (
                this.showShareButton() ||
                this.showFilesAccessButton() ||
                this.showCollectionsAccessButton()
              )
            ) && (
            <NavItem>
              <NavLink
                id="ABShare"
                href="#share"
                onClick={(e) => {
                  e.preventDefault();
                  if (this.showFilesAccessButton()) {
                    handleChangeFilesAccess(selectedFiles.map(sf => (sf.uuid)));
                  } else if (this.showCollectionsAccessButton()) {
                    handleChangeCollectionsAccess(selectedCollections.map(sc => (sc.uuid)));
                  } else {
                    handleShare(selectedCollections, selectedFiles);
                  }
                }}
                disabled={lockSelectedAllFilesAction}
              >
                <i className="far fa-share-alt" />
              </NavLink>
              <UncontrolledTooltip fade={false} placement="top" target="ABShare">
                {this.getShareLabel()}
              </UncontrolledTooltip>
            </NavItem>
            )}
            {(
              share &&
              this.showChangeStatusButton() && totalSelectedCollections === 0
            ) && (
            <NavItem>
              <NavLink
                id="ABChangeStatus"
                href="#change-status"
                onClick={(e) => upgradeModalIfNeeded('file-status', () => {
                  e.preventDefault();
                  handleChangeStatus(selectedFiles);
                }, e)}
                disabled={lockSelectedAllFilesAction || (!userHasFeature('file-status') && (!share || !share.status_change))}
              >
                <i className="far fa-circle-dot" />
              </NavLink>
              <UncontrolledTooltip fade={false} placement="top" target="ABChangeStatus">
                {lockSelectedAllFilesAction ?
                  intl.formatMessage({ defaultMessage: 'Load all files to change status' }) :
                  intl.formatMessage({ defaultMessage: 'Change status' })}
              </UncontrolledTooltip>
            </NavItem>
            )}
            {(!share && totalSelectedCollections === 0) && (
              <NavItem>
                <NavLink
                  id="ABEditCollections"
                  href="#edit-files"
                  onClick={(e) => {
                    e.preventDefault();
                    const links = selectedFiles.filter(sf => (sf.type === 'link')).length;
                    handleEditFiles(links > 0 ? 'link' : 'edit');
                  }}
                  disabled={lockSelectedAllFilesAction || !this.showEditButton()}
                  aria-label={this.getEditLabel()}
                >
                  <i className="far fa-edit" />
                </NavLink>
                <UncontrolledTooltip fade={false} placement="top" target="ABEditCollections">
                  {this.getEditLabel()}
                </UncontrolledTooltip>
              </NavItem>
            )}
            {!share && (
              <UncontrolledDropdown nav inNavbar direction="up" className="action-more">
                <DropdownToggle
                  nav
                  className={classnames('nav-profile', { disabled: lockSelectedAllFilesAction })}
                  disabled={lockSelectedAllFilesAction}
                  id="ABActionMore"
                  aria-label={intl.formatMessage({ defaultMessage: 'More actions' })}
                >
                  <i className="far fa-ellipsis-h" />
                </DropdownToggle>
                {lockSelectedAllFilesAction && (
                  <UncontrolledTooltip fade={false} placement="top" target="ABActionMore">
                    {intl.formatMessage({ defaultMessage: 'Load all files for more' })}
                  </UncontrolledTooltip>
                )}
                <DropdownMenu
                  disabled={lockSelectedAllFilesAction}
                  right
                >
                  {(!share && this.showDeleteCollectionsButton()) && (
                    <DropdownItem
                      onClick={() => {
                        this.handleDeleteCollections();
                      }}
                    >
                      <i className="fas fa-trash" />
                      {intl.formatMessage({ defaultMessage: 'Delete' })}
                    </DropdownItem>
                  )}
                  {(!share && this.showDeleteFilesButton()) && (
                    <DropdownItem
                      onClick={() => {
                        this.handleDeleteFiles();
                      }}
                    >
                      <i className="fas fa-trash" />
                      {intl.formatMessage({ defaultMessage: 'Delete' })}
                    </DropdownItem>
                  )}
                  {(
                    !share &&
                    this.showWatermarkButton() && totalSelectedCollections === 0
                  ) && (
                  <DropdownItem
                    onClick={() => upgradeModalIfNeeded('watermarking', () => handleChangeWatermarked(selectedFiles))}
                    disabled={!watermarkEnabled}
                    className={classnames('watermark-dropdown dropdown-with-notice', {
                      disabled: !watermarkEnabled,
                    })}
                  >
                    <div>
                      <i className="far fa-stamp" />
                      {intl.formatMessage({ defaultMessage: 'Watermark' })}
                      <UpgradePlanButton
                        feature="watermarking"
                        simple={true}
                      />
                    </div>
                    {((userIsAdmin() || userIsManager()) && !watermarkEnabled) && (
                    <div className="dropdown-notice">
                      {intl.formatMessage({ defaultMessage: 'Add a watermark in your <link>workspace settings</link>' }, {
                        link: (msg) => (
                          <Link to="/admin/workspace" className="prevent-upgrade-modal">
                            {msg}
                          </Link>
                        ),
                      })}
                    </div>
                    )}
                  </DropdownItem>
                  )}
                  {(
                    !share &&
                    this.showChangeStatusButton() && totalSelectedCollections === 0
                  ) && (
                  <DropdownItem
                    onClick={(e) => upgradeModalIfNeeded('file-status', () => handleChangeStatus(selectedFiles), e)}
                    disabled={!userHasFeature('file-status')}
                  >
                    <i className="far fa-circle-dot" />
                    {intl.formatMessage({ defaultMessage: 'Change Status' })}
                    <UpgradePlanButton
                      feature="file-status"
                      simple={true}
                    />
                  </DropdownItem>
                  )}
                  {this.showChangeFilesOwnerButton() && (
                    <DropdownItem
                      onClick={() => {
                        handleChangeFilesOwner(selectedFiles.map(sf => (sf.uuid)));
                      }}
                    >
                      <i className="fas fa-user-circle" />
                      {intl.formatMessage({ defaultMessage: 'Change Owner' })}
                    </DropdownItem>
                  )}
                  {this.showChangeCollectionsOwnerButton() && (
                    <DropdownItem
                      onClick={() => {
                        handleChangeCollectionsOwner(selectedCollections);
                      }}
                    >
                      <i className="fas fa-user-circle" />
                      {intl.formatMessage({ defaultMessage: 'Change Owner' })}
                    </DropdownItem>
                  )}
                  {(totalSelectedFiles > 0 && totalSelectedCollections === 0) && (
                    <CopyToClipboard
                      text={selectedFiles.map(sf => (sf.uuid)).join('\n')}
                      options={{
                        format: 'text/plain',
                      }}
                    >
                      <DropdownItem
                        onClick={() => {
                          addFlashMessage({
                            type: 'success',
                            text: intl.formatMessage({
                              defaultMessage: 'File {totalSelectedFiles, plural, one {ID} other {IDs}} has been copied',
                            }, {
                              totalSelectedFiles,
                            }),
                          });
                        }}
                      >
                        <i className="fas fa-copy" />
                        {intl.formatMessage({
                          defaultMessage: 'Copy {totalSelectedFiles, plural, one {ID} other {IDs}}',
                        }, {
                          totalSelectedFiles,
                        })}
                      </DropdownItem>
                    </CopyToClipboard>
                  )}
                  {this.showDownloadButton() && (
                    <FileActionsIntegrations files={selectedFiles} />
                  )}
                  {(this.showArchiveButton() && userCan('file.archive')) && (
                    <>
                      <DropdownItem divider />
                      {isArchive() ? (
                        <DropdownItem
                          className={classnames({ 'inactive silent-pointer-events': !userHasFeature('archive') })}
                          onClick={(e) => upgradeModalIfNeeded('archive', () => handleArchive(selectedCollections, selectedFiles, 'unarchive'), e)}
                        >
                          <i className="fas fa-box-open" />
                          {intl.formatMessage({ defaultMessage: 'Unarchive' })}
                          <UpgradePlanButton
                            feature="archive"
                            simple={true}
                          />
                        </DropdownItem>
                      ) : (
                        <DropdownItem
                          className={classnames({ 'inactive silent-pointer-events': !userHasFeature('archive') })}
                          onClick={(e) => upgradeModalIfNeeded('archive', () => handleArchive(selectedCollections, selectedFiles, 'archive'), e)}
                        >
                          <i className="fas fa-archive" />
                          {intl.formatMessage({ defaultMessage: 'Archive' })}
                          <UpgradePlanButton
                            feature="archive"
                            simple={true}
                          />
                        </DropdownItem>
                      )}
                    </>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </Nav>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  share: state.Shares.share,
  files: state.Files.files,
  filesTotal: state.Files.filesTotal,
  selectedFiles: state.Files.selectedFiles,
  selectedAllFiles: state.Files.selectedAllFiles,
  collectionsTotal: state.Collections.collectionsTotal,
  selectedCollections: state.Collections.selectedCollections,
  selectedAllCollections: state.Collections.selectedAllCollections,
  collection: state.Collections.collection,
  sidebarCollection: state.Collections.sidebarCollection,
  reorderingMode: state.Files.reorderingMode,
  collectionMoveModal: state.Collections.moveModalOpen,
});

const mapDispatchToProps = (dispatch, props) => ({
  selectFiles: (files) => {
    dispatch(setSelectedFiles(files));
  },
  unselectAllFiles: () => {
    dispatch(setSelectedFiles([]));
    dispatch(setSelectedAllFiles(false));
  },
  unselectAllCollections: () => {
    dispatch(setSelectedCollections([]));
    dispatch(setSelectedAllCollections(false));
  },
  unselectAllFilesAndCollections: () => {
    dispatch(setSelectedFiles([]));
    dispatch(setSelectedAllFiles(false));
    dispatch(setSelectedCollections([]));
    dispatch(setSelectedAllCollections(false));
  },
  handleAddToCollection: (e) => {
    e.preventDefault();
    dispatch(showCollectionAddModal());
  },
  handleAddToSidebarCollection: (collectionUuid, files) => {
    APIaddFilesToCollection(collectionUuid, {
      files: files.map(f => (f.uuid)),
    }).then((response) => {
      dispatch(setSidebarCollection(response.data, false));
    });

    const cstate = getState();
    const { files: loadedFiles } = cstate.Files;
    const nFiles = files.map((file) => {
      let { urls } = file;
      if (!urls) {
        const f = loadedFiles.find(fl => (fl.uuid === file.uuid));
        if (f && f.urls) {
          ({ urls } = f);
        }
      }
      return {
        ...file,
        urls,
      };
    });

    dispatch(addFilesToSidebarCollectionFilesList(nFiles));

    const { intl } = props;
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({
        defaultMessage: 'Files have been added to Collection',
      }),
    });
  },
  handleMoveToCollection: (e) => {
    e.preventDefault();
    dispatch(showCollectionAddModal(true));
  },
  handleMoveCollectionToCollection: () => {
    dispatch(showCollectionMoveModal());
  },
  openConfirmationModal: (params) => {
    dispatch(showConfirmationModal(params));
  },
  deleteFilesFromCollection: (collectionUuid, params) => (
    APIcreateFilesGroup({
      type: 'collection_remove_files',
      data: { collection_uuid: collectionUuid },
    }).then((response) => {
      const { intl } = props;
      const fileGroupUuid = response.data.uuid;
      return dispatch(removeFilesFromCollection(collectionUuid, {
        ...params,
        files: params.selectedAllFiles ? [] : params.files,
        fileGroupUuid,
      })).then(() => {
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({
            defaultMessage: 'Files have been removed from Collection',
          }),
        });
        dispatch(removeFilesFromFilesList(params.files.map(f => ({ uuid: f }))));
      });
    })
  ),
  handleEditFiles: (mode) => {
    dispatch(setUploadModalMode(mode));
    dispatch(showUploadModal());
  },
  deleteFilesAction: (params) => (
    dispatch(deleteFiles({
      ...params,
      files: params.selectedAllFiles ? [] : params.files,
    })).then((response) => {
      const { intl } = props;
      const { errors } = response;
      if (errors > 0) {
        addFlashMessage({
          type: 'warning',
          text: intl.formatMessage({
            defaultMessage: `You don't have permissions to delete some of the selected files`,
          }),
        });
      } else {
        const button = {
          url: '/trash',
          text: intl.formatMessage({ defaultMessage: 'Browse trash' }),
        };
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({
            defaultMessage: 'Files have been deleted',
          }),
          button,
        });
        dispatch(removeFilesFromFilesList(params.files.map(f => ({ uuid: f }))));
      }
    })
  ),
  deleteFilesPermanentAction: (params) => (
    dispatch(deleteFilesPermanent({
      ...params,
      files: params.selectedAllFiles ? [] : params.files,
    })).then((response) => {
      const { intl } = props;
      const { errors } = response;
      if (errors > 0) {
        addFlashMessage({
          type: 'warning',
          text: intl.formatMessage({
            defaultMessage: `You don't have permissions to delete some of the selected files`,
          }),
        });
      } else {
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({
            defaultMessage: 'Files have been deleted permanently',
          }),
        });
        dispatch(removeFilesFromFilesList(params.files.map(f => ({ uuid: f }))));
      }
    })
  ),
  restoreFilesAction: (params) => (
    dispatch(restoreDeletedFiles({
      ...params,
      files: params.selectedAllFiles ? [] : params.files,
    })).then((response) => {
      const { intl } = props;
      const { errors } = response;
      if (errors > 0) {
        addFlashMessage({
          type: 'warning',
          text: intl.formatMessage({
            defaultMessage: `You don't have permissions to restore some of the selected files`,
          }),
        });
      } else {
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({
            defaultMessage: 'Files have been restored',
          }),
        });
        dispatch(removeFilesFromFilesList(params.files.map(f => ({ uuid: f }))));
      }
    })
  ),
  openRemoveCollectionModal: (params) => {
    dispatch(showModal('RemoveModal', params));
  },
  removeCollections: ({
    collectionUuidList,
    progressCollectionsUuid,
    progressFilesUuid,
    withFiles = false,
  }) => (
    dispatch(deleteCollections({
      collectionUuidList,
      progressCollectionsUuid,
      progressFilesUuid,
      withFiles,
    }))
  ),
  removeCollectionsPermanent: ({ collectionUuidList, progressFilesUuid, withFiles = false }) => (
    dispatch(deleteCollectionsPermanent({
      collectionUuidList,
      progressFilesUuid,
      withFiles,
    }))
  ),
  handleDownload: (collections, files, share) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      collections,
      files,
      shareUuid: share ? share.uuid : null,
      requireName: share ? share.require_name : false,
      requireEmail: share ? share.require_email : false,
      backdrop: true,
    }));
  },
  handleRequestDownload: (collections, files) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      collections,
      files,
      backdrop: true,
      request: true,
    }));
  },
  handleDownloadRequest: (collections, files, request) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      collections,
      files,
      requestUuid: request.uuid,
      availableFileSizes: request.file_sizes.map(fs => (`${fs.id}`)),
      backdrop: true,
    }));
  },
  handleShare: (collections, files) => {
    dispatch(showModal('ShareModal', {
      className: 'modal-share modal-share-file',
      files: files.filter(f => (userCan('file.share', f))),
      collections: collections.filter(c => (userCan('collection.share', c))),
    }));
  },
  handleChangeStatus: (files) => {
    dispatch(showModal('StatusModal', {
      className: 'status-change',
      files,
      backdrop: true,
      request: true,
    }));
  },
  handleChangeWatermarked: (files) => {
    dispatch(showModal('WatermarkedModal', {
      className: 'modal-watermarked-change',
      files,
      backdrop: true,
    }));
  },
  handleChangeFilesOwner: (files) => {
    dispatch(showModal('ChangeOwnerModal', {
      className: 'modal-change-owner',
      files,
    }));
  },
  handleChangeCollectionsOwner: (collections) => {
    dispatch(showModal('ChangeOwnerModal', {
      className: 'modal-change-owner',
      collections,
    }));
  },
  handleChangeFilesAccess: (files) => {
    dispatch(showModal('AccessModal', {
      className: 'modal-access modal-file-access',
      files,
    }));
  },
  handleChangeCollectionsAccess: (collections) => {
    dispatch(showModal('AccessModal', {
      className: 'modal-access modal-file-access',
      collections,
    }));
  },
  handleArchive: (collections, files, action) => {
    dispatch(showModal('ArchiveModal', {
      className: 'modal-archive modal-file-archive',
      files,
      collections,
      action,
    }));
  },
  openCollectionRestoreModal: (params) => {
    dispatch(showModal('CollectionRestoreModal', params));
  },
});

ActionbarWorkspaceActions.propTypes = {
  intl: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  share: PropTypes.object,
  files: PropTypes.array.isRequired,
  filesTotal: PropTypes.number.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  selectedAllFiles: PropTypes.bool.isRequired,
  selectFiles: PropTypes.func.isRequired,
  selectedCollections: PropTypes.array.isRequired,
  selectedAllCollections: PropTypes.bool.isRequired,
  unselectAllFiles: PropTypes.func.isRequired,
  unselectAllCollections: PropTypes.func.isRequired,
  handleAddToCollection: PropTypes.func.isRequired,
  handleAddToSidebarCollection: PropTypes.func.isRequired,
  handleMoveToCollection: PropTypes.func.isRequired,
  handleMoveCollectionToCollection: PropTypes.func.isRequired,
  openConfirmationModal: PropTypes.func.isRequired,
  deleteFilesFromCollection: PropTypes.func.isRequired,
  handleEditFiles: PropTypes.func.isRequired,
  deleteFilesAction: PropTypes.func.isRequired,
  deleteFilesPermanentAction: PropTypes.func.isRequired,
  restoreFilesAction: PropTypes.func.isRequired,
  removeCollections: PropTypes.func.isRequired,
  removeCollectionsPermanent: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  handleRequestDownload: PropTypes.func.isRequired,
  handleDownloadRequest: PropTypes.func.isRequired,
  handleShare: PropTypes.func.isRequired,
  handleChangeStatus: PropTypes.func.isRequired,
  handleChangeWatermarked: PropTypes.func.isRequired,
  handleChangeFilesOwner: PropTypes.func.isRequired,
  handleChangeCollectionsOwner: PropTypes.func.isRequired,
  handleChangeFilesAccess: PropTypes.func.isRequired,
  handleChangeCollectionsAccess: PropTypes.func.isRequired,
  handleArchive: PropTypes.func.isRequired,
  collection: PropTypes.object,
  sidebarCollection: PropTypes.object,
  reorderingMode: PropTypes.bool.isRequired,
  openRemoveCollectionModal: PropTypes.func.isRequired,
  openCollectionRestoreModal: PropTypes.func.isRequired,
};

ActionbarWorkspaceActions.defaultProps = {
  share: null,
  collection: null,
  sidebarCollection: null,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ActionbarWorkspaceActions));
